/** Shared display helpers for the agents platform pages. */
import { formatFixed } from "./i18n";

export function formatTokens(n: number): string {
  if (n >= 1_000_000) return `${formatFixed(n / 1_000_000, 1)}M`;
  if (n >= 1_000) return `${formatFixed(n / 1_000, 1)}k`;
  return formatFixed(n, 0);
}

export function formatUsd(n: number): string {
  return `$${formatFixed(n, n >= 1 ? 2 : 3)}`;
}
